import { siteInfo, aboutContent } from "@/mocks/videoData";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/base/Breadcrumb";

export default function About() {
  return (
    <>
      <Navbar />
      <main className="pt-16">
        <div className="bg-background-50 border-b border-background-200">
          <div className="max-w-[1440px] mx-auto">
            <Breadcrumb items={[{ name: "关于我们" }]} />
          </div>
        </div>

        {/* 品牌介绍 */}
        <section className="py-12 md:py-16 bg-background-50">
          <div className="max-w-[900px] mx-auto px-4 md:px-6">
            <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-6">
              关于 {siteInfo.name}
            </h1>
            <p className="text-sm text-foreground-500 text-center mb-10">
              成立于 {siteInfo.founded} 年，国内领先的在线视频资源聚合平台
            </p>

            <div className="bg-background-50 border border-background-200 rounded-lg p-6 md:p-8">
              <h2 className="text-lg font-semibold text-foreground-950 mb-4">{aboutContent.intro.title}</h2>
              {aboutContent.intro.content.split("\n\n").map((paragraph, i) => (
                <p key={i} className="text-foreground-700 leading-relaxed mb-4">{paragraph}</p>
              ))}
            </div>

            {/* 数据亮点 */}
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-8">
              {[
                { value: "5000万+", label: "活跃用户" },
                { value: "2亿+", label: "日播放量" },
                { value: "10万+", label: "视频资源" },
                { value: "5年+", label: "行业经验" },
              ].map((stat) => (
                <div key={stat.label} className="text-center p-4 rounded-lg bg-accent-100 border border-accent-200">
                  <div className="text-xl md:text-2xl font-bold text-accent-900 mb-1">{stat.value}</div>
                  <div className="text-xs text-foreground-600">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* 口碑评价 */}
        <section className="py-12 md:py-16 bg-background-100">
          <div className="max-w-[1100px] mx-auto px-4 md:px-6">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 text-center mb-10">
              {aboutContent.reputation.title}
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {aboutContent.reputation.items.map((item, i) => (
                <div key={i} className="bg-background-50 border border-background-200 rounded-lg p-5">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center text-primary-500 font-bold text-sm">
                      {item.name.charAt(0)}
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-950">{item.name}</div>
                      <div className="text-xs text-foreground-500">{item.role}</div>
                    </div>
                    <div className="ml-auto flex gap-0.5">
                      {Array.from({ length: item.rating }).map((_, j) => (
                        <i key={j} className="ri-star-fill text-yellow-500 text-sm"></i>
                      ))}
                    </div>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.content}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* 联系我们 */}
        <section className="py-12 md:py-16 bg-background-50">
          <div className="max-w-[700px] mx-auto px-4 md:px-6">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 text-center mb-6">
              {aboutContent.contact.title}
            </h2>
            <p className="text-sm text-foreground-600 text-center mb-8">
              {aboutContent.contact.description}
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
              <div className="bg-background-50 border border-background-200 rounded-lg p-5 text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100">
                  <i className="ri-mail-line text-xl text-primary-500"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-950 mb-1">电子邮箱</h3>
                <p className="text-sm text-foreground-600">{siteInfo.email}</p>
              </div>
              <div className="bg-background-50 border border-background-200 rounded-lg p-5 text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100">
                  <i className="ri-phone-line text-xl text-primary-500"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-950 mb-1">客服电话</h3>
                <p className="text-sm text-foreground-600">{siteInfo.phone}</p>
              </div>
              <div className="bg-background-50 border border-background-200 rounded-lg p-5 text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100">
                  <i className="ri-time-line text-xl text-primary-500"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-950 mb-1">工作时间</h3>
                <p className="text-sm text-foreground-600">{aboutContent.contact.workingHours}</p>
              </div>
            </div>

            <div className="bg-background-50 border border-background-200 rounded-lg p-6">
              <h3 className="text-sm font-semibold text-foreground-950 mb-2">公司地址</h3>
              <p className="text-sm text-foreground-600">{siteInfo.address}</p>
            </div>
          </div>
        </section>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "BreadcrumbList",
                itemListElement: [
                  {
                    "@type": "ListItem",
                    position: 1,
                    name: "首页",
                    item: siteInfo.url,
                  },
                  {
                    "@type": "ListItem",
                    position: 2,
                    name: "关于我们",
                    item: `${siteInfo.url}/about`,
                  },
                ],
              },
              {
                "@type": "Organization",
                name: siteInfo.name,
                url: siteInfo.url,
                description: siteInfo.description,
                email: siteInfo.email,
                telephone: siteInfo.phone,
                address: {
                  "@type": "PostalAddress",
                  streetAddress: siteInfo.address,
                  addressLocality: "北京",
                  addressCountry: "CN",
                },
                foundingDate: siteInfo.founded,
              },
              {
                "@type": "WebPage",
                url: `${siteInfo.url}/about`,
                name: `关于我们 - ${siteInfo.name}`,
              },
            ],
          }),
        }}
      />
    </>
  );
}